/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getPublicAmazonProductVariants.internal

import kangaroorewards.appsdk.core.network.base.Endpoint

/**
 * The HTTP endpoint for the [GetPublicAmazonProductVariantsApi].
 *
 * [Endpoint] has a single [Endpoint.path] parameter ex. "users/me"
 */
internal val GetPublicAmazonProductVariantsEndpoint = Endpoint(path = "public/rewards/{rewardSlug}?include=external_products,external_product_variants&external_product_id={externalProductId}")
